import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderPayers: build.query<
      GetV2ProviderPayersApiResponse,
      GetV2ProviderPayersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/payers`,
        params: {
          search: queryArg.search,
          per_page: queryArg.perPage,
          page_token: queryArg.pageToken,
        },
      }),
    }),
    getV2ProviderPayersByPayerId: build.query<
      GetV2ProviderPayersByPayerIdApiResponse,
      GetV2ProviderPayersByPayerIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/provider/payers/${queryArg.payerId}` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderPayersApiResponse =
  /** status 200 OK */ PayerSearchResponse;
export type GetV2ProviderPayersApiArg = {
  /** Search term - searches payer name, primary payer ID, and aliases. Supports fuzzy matching for typos. */
  search?: string | null;
  /** Number of results per page (10-100) */
  perPage?: number;
  /** Token for fetching the next page of results. Returned as 'next_page_token' in previous response. */
  pageToken?: string | null;
};
export type GetV2ProviderPayersByPayerIdApiResponse =
  /** status 200 OK */ PayerResponse2;
export type GetV2ProviderPayersByPayerIdApiArg = {
  payerId: string;
};
export type PayerResponse = {
  aliases?: string[];
  avatar_url?: string | null;
  coverage_types?: string[];
  display_name: string;
  /** Enrollment process info per transaction type. Contains type (ONE_CLICK, STANDARD) and timeframe (DAYS, WEEKS) */
  enrollment_info?: {
    [key: string]: any;
  } | null;
  id?: string | null;
  operating_states?: string[];
  primary_payer_id?: string | null;
  stedi_id: string;
  /** Transaction support levels. Keys: eligibilityCheck, professionalClaimSubmission, claimPayment, etc. Values: SUPPORTED, ENROLLMENT_REQUIRED, NOT_SUPPORTED */
  transaction_support?: {
    [key: string]: string;
  };
  website_url?: string | null;
};
export type PayerSearchResponse = {
  items: PayerResponse[];
  /** Token to fetch the next page. Pass as 'page_token' query param. Null when no more results. */
  next_page_token?: string | null;
  per_page: number;
  total: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type PayerResponse2 = {
  aliases?: string[];
  avatar_url?: string | null;
  coverage_types?: string[];
  display_name: string;
  /** Enrollment process info per transaction type. Contains type (ONE_CLICK, STANDARD) and timeframe (DAYS, WEEKS) */
  enrollment_info?: {
    [key: string]: any;
  } | null;
  id?: string | null;
  operating_states?: string[];
  primary_payer_id?: string | null;
  stedi_id: string;
  /** Transaction support levels. Keys: eligibilityCheck, professionalClaimSubmission, claimPayment, etc. Values: SUPPORTED, ENROLLMENT_REQUIRED, NOT_SUPPORTED */
  transaction_support?: {
    [key: string]: string;
  };
  website_url?: string | null;
};
